import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { animateScroll as scroll } from 'react-scroll';

import Animated from 'src/shared/components/Animated/Animated';
import { GTM_EVENTS, propsSmoothScrollLastMenuLinks } from 'src/shared/constants';
import { gtmUtils } from 'src/shared/toolbox';

import styles from './BackToTopFloatButton.module.scss';

const BackToTopFloatButton = () => {
	const [showOnScroll, setShowOnScroll] = useState(false);

	useScrollPosition(
		({ currPos }) => {
			const isShow = currPos.y > 100;
			if (isShow !== showOnScroll) setShowOnScroll(isShow);
		},
		[showOnScroll],
		undefined,
		true
	);

	const goBackToTop = () => {
		scroll.scrollToTop({
			smooth: propsSmoothScrollLastMenuLinks.smooth,
			duration: propsSmoothScrollLastMenuLinks.duration,
			delay: propsSmoothScrollLastMenuLinks.delay
		});
		gtmUtils.pushDataLayerGTM(GTM_EVENTS.BACK_TO_TOP_CLICK);
	};

	return (
		<Animated
			animationIn="slideInRight"
			animationInDuration={800}
			animationOut="slideOutRight"
			animationOutDuration={800}
			isVisible={showOnScroll}
			className={styles.container}
		>
			<button
				id="back_to_top_float_button"
				data-testid="back-to-top-float-button"
				type="button"
				className={styles.button}
				onClick={goBackToTop}
			>
				<FontAwesomeIcon icon={'chevron-up'} className={styles.icon} />
			</button>
		</Animated>
	);
};

export default BackToTopFloatButton;
